const ACTIVITY_CHIN_GROUP_TYPES = new Set([
    "group",
    "group-one-off",
    "dm",
]);

/**
 * @param {object} participant
 * @returns {object | null}
 */
export function mapConversationParticipantToChinUser(participant) {
    if (!participant?.id) {
        return null;
    }

    return {
        id: participant.id,
        name: participant.full_name ?? participant.name,
        disabled: Boolean(participant.disabled),
        imageSrc: participant.avatar_url ?? participant.imageSrc,
        is_association_ended: participant.is_active === 0,
        is_agent: Boolean(participant.is_agent),
    };
}

/**
 * @param {object | null | undefined} conversation
 * @returns {object[]}
 */
export function getActivityChinUsersFromConversationParticipants(conversation) {
    if (!conversation) {
        return [];
    }

    const conversation_type = conversation.type;
    const participants = conversation.getParticipants?.() ?? [];

    if (!ACTIVITY_CHIN_GROUP_TYPES.has(conversation_type)) {
        return [];
    }

    if (conversation_type === "dm" && participants.length === 2) {
        return participants
            .filter((participant) => !participant?.is_removed)
            .map(mapConversationParticipantToChinUser)
            .filter(Boolean);
    }

    return participants
        .filter(
            (participant) =>
                !participant?.is_removed && !participant?.is_agent,
        )
        .map(mapConversationParticipantToChinUser)
        .filter(Boolean);
}

/**
 * @param {object | null | undefined} conversation
 * @returns {object[] | null} `null` when invite API should be used.
 */
export function getActivityChinUsersFromConversationState(conversation) {
    if (!conversation) {
        return [];
    }

    const fromGroups = getActivityChinUsersFromConversationParticipants(
        conversation,
    );
    if (ACTIVITY_CHIN_GROUP_TYPES.has(conversation.type)) {
        return fromGroups;
    }

    const activeParticipants =
        conversation.getActiveParticipats?.() ??
        (conversation.getParticipants?.() ?? []).filter(
            (participant) => !participant?.is_removed,
        );

    if (!activeParticipants.length) {
        return null;
    }

    return activeParticipants
        .filter((participant) => !participant?.is_agent)
        .map(mapConversationParticipantToChinUser)
        .filter(Boolean);
}

/**
 * @param {object | null | undefined} conversation
 * @returns {object[]}
 */
export function getActivityChinUsersSnapshot(conversation) {
    const fromState = getActivityChinUsersFromConversationState(conversation);

    return fromState ?? [];
}
